<template>
  <div>
    <div class="dropdown is-right is-hoverable">
      <div class="dropdown-trigger">
        <button class="button is-uppercase">
          <span>{{ activeLanguage }}</span>
          <span class="icon is-small">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <div
            class="dropdown-item"
            v-for="language in languages"
            :key="language"
          >
            <a
              class="navbar-item is-uppercase"
              @click="$emit('changeLanguage', language)"
              >{{ language }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    languages: {
      type: Array,
      default () {
        return ['en', 'es', 'ca']
      }
    },
    activeLanguage: {
      type: String
    }
  }
}
</script>

<style>
</style>
